import { render, staticRenderFns } from "./LastView.vue?vue&type=template&id=f0694ea6&scoped=true"
import script from "./LastView.vue?vue&type=script&lang=js"
export * from "./LastView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0694ea6",
  null
  
)

export default component.exports